import React, { useEffect, useState } from 'react';
import { SettingsType } from '../interfaces/SettingsType';

interface EditEntryCodeProps {
  settings: SettingsType | undefined;
  updateSettings: (settings: SettingsType) => void;
}

const EditEntryCode: React.FC<EditEntryCodeProps> = ({
  settings,
  updateSettings,
}) => {
  const [zugangscode, setZugangscode] = useState('');
  const [editedZugangscode, setEditedZugangscode] = useState('');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  useEffect(() => {
    if (settings) {
      setZugangscode(settings.zugangscode);
    }
  }, [settings]);

  const handleEditClick = (index: number) => {
    setEditingIndex(index);
  };

  const handleSaveClickZugangsode = () => {
    if (editingIndex !== null && settings !== undefined) {
      setZugangscode(editedZugangscode);
      setEditingIndex(null);
      updateSettings({ ...settings, zugangscode: editedZugangscode });
    }
  };

  const handleCancelClick = () => {
    setEditingIndex(null);
    setEditedZugangscode('');
  };

  console.log(settings);
  return (
    <>
      <h3>Zugriffscode</h3>
      <div className="email-item">
        {editingIndex === -1 ? (
          <div className="edit-container">
            <input
              type="text"
              value={editedZugangscode}
              onChange={(e) => setEditedZugangscode(e.target.value)}
              className="edit-input"
            />
            <button onClick={handleSaveClickZugangsode} className="save-button">
              Speichern
            </button>
            <button onClick={handleCancelClick} className="cancel-button">
              Abbrechen
            </button>
          </div>
        ) : (
          <>
            <span className="email-text">{zugangscode}</span>
            <button onClick={() => handleEditClick(-1)} className="edit-button">
              Edit
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default EditEntryCode;
